import React, { useId } from "react";
import "./review-radio.css";
export default function ReviewRadioGroup({ label, value = "unknown", onChange, disabled = false }) {
  const id = useId();
  return <fieldset className="review-radio" disabled={disabled}>
    <legend className="review-radio-legend">{label}</legend>
    <div className="review-radio-row">
    <span aria-hidden="true" className="review-radio-label">{label}</span>
    <div className="review-radio-options">
      {[["unknown", "Needs review"], ["yes", "Yes"], ["no", "No"]].map(([choice, text]) =>
        <label key={choice} className={value === choice ? "selected" : ""}>
          <input type="radio" name={id} value={choice} checked={value === choice} onChange={() => onChange(choice)} />{text}
        </label>)}
    </div>
    </div>
  </fieldset>;
}
